import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get saleCreditNote
export const getSaleCreditNote = createAsyncThunk(
  "saleCreditNote/getSaleCreditNote",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getSaleCreditNote({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all saleCreditNote
export const getAllSaleCreditNote = createAsyncThunk(
  "saleCreditNote/getAllSaleCreditNote",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllSaleCreditNote();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("saleCreditNote/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleCreditNote/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleCreditNote/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleCreditNote({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getSaleCreditNoteById = createAsyncThunk(
  "saleCreditNote/getSaleCreditNoteById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleCreditNoteById(id);

      if (data?.data.drCrNotesDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.drCrNotesDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, drCrNotesDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create saleCreditNote
export const createSaleCreditNote = createAsyncThunk(
  "saleCreditNote/createSaleCreditNote",
  async (createData, { rejectWithValue }) => {
    const {
      salesOrderMain,
      drCrNotesDetails,

      drCrNotesPartyDetails,
      salesOrderMainVehicleDetail,
      // invoiceNo,
      // refNo,
      voucherDateBs,
      voucherDate,
      narration,
      branch,
      deliveryDocNo,
      termsOfPayment,
      salesOrderRequest,
      partyAccount,
      otherReferences,
      termsOfDelivery,
      destination,
      deliveryThrough,
      deliveryDocNumber,
      find,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        salesOrderMain,
        drCrNotesDetails,

        drCrNotesPartyDetails,
        salesOrderMainVehicleDetail,
        noteType: "sales_credit",
        // invoiceNo,
        // refNo,
        voucherDateBs,
        voucherDate,
        branch,
        deliveryDocNo,
        termsOfPayment,
        narration,
        salesOrderRequest,
        partyAccount,
        otherReferences,
        termsOfDelivery,
        destination,
        deliveryThrough,
        deliveryDocNumber,
        find,
        grandTotal,
        vatAmount,
      });

      const { data } = await API.createSaleCreditNote(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSaleCreditNote = createAsyncThunk(
  "saleCreditNote/updateSaleCreditNote",
  async (params, { rejectWithValue }) => {
    const { id, submitData } = params;
    const {
      salesOrder,
      indentNo,
      voucherDateBs,
      voucherDate,
      branch,
      drCrNotesPartyDetails,
      salesOrderMainVehicleDetail,
      // yo field name mileko thiyena, fix bhayo hai
      documentsAttach,
      // refVoucher,
      drCrNotesDetails,
    } = submitData;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        branch,
        status: "approved",
        drCrNotesPartyDetails,
        salesOrderMainVehicleDetail,
        voucherDateBs,
        voucherDate,
        // refVoucher,
        drCrNotesDetails,
      });
      const { data } = await API.updateSaleCreditNote(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getSaleCreditNoteDetailsById = createAsyncThunk(
  "saleCreditNote/getSaleCreditNoteDetailsById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleCreditNoteDetailsById(id);

      if (data?.data.saleInvoiceDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.saleInvoiceDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, saleOrderDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "saleCreditNote/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
